/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Button, Slider, Box, styled, Select, MenuItem, FormControl, InputLabel, OutlinedInput, Chip } from "@mui/material";

import { Chart as ChartJS, registerables } from 'chart.js';
import { API_URL } from '../../api-config.js';
import { Scatter } from 'react-chartjs-2';
import Typography from '@mui/material/Typography';
import GaugeChart from 'react-gauge-chart'
import { useTheme, useMediaQuery } from '@mui/material';
import axios from "axios";
ChartJS.register(...registerables);


const SystemTrades = () => {
    const [trades, setTrades] = useState([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const chartHeight = isMobile ? '90vh' : '400px';
    const [selectedFilters, setSelectedFilters] = useState({
      signals: [],
      types: [],
      months: [],
      years: [],
    });
  
    useEffect(() => {
      
      const token = localStorage.getItem("token");
      const fetchTrades = async () => {
        let data ;
        await axios.get(`${API_URL}/trading-api/sistema/trades`,
        { headers: { "Content-Type": "application/json",
          "Authorization": "Bearer "+ token
         }}).then((response) => {
          data = response.data; 
         })
        console.log('trades', data)
        setTrades(data);
      };
  
      fetchTrades();
    }, []);
  
    if (!trades || trades.length === 0) {
        return <div>Loading...</div>; // O cualquier otro placeholder que prefieras
      }
    // Asumiendo que tienes funciones para generar arrays de `types`, `months`, y `years`
    // Por simplicidad, aquí se usarán valores estáticos como ejemplo
    const uniqueSignals = [...new Set(trades.map(trade => trade.Signal))].sort();
    const uniqueTypes = [...new Set(trades.map(trade => trade.Type))].sort();
    const uniqueYears = [...new Set(trades.map(trade => new Date(trade.Datetime_Cierre).getFullYear()))].sort();
  
    const monthOptions = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  
    const handleFilterClick = (filterType, value) => {
      console.log(`Agregando al filtro ${filterType}:`, value);
      setSelectedFilters(prev => ({
        ...prev,
        [filterType]: prev[filterType].includes(value)
          ? prev[filterType].filter(item => item !== value) // Deseleccionar
          : [...prev[filterType], value], // Seleccionar
      }));
    };
  
    // Ejemplo de cómo podrían aplicarse estos filtros
    const filteredTrades = trades.filter(trade => {
      const tradeDate = new Date(trade.Datetime_Cierre);
      const tradeMonth = tradeDate.getMonth() + 1; // Ajustando para coincidir con la selección del usuario (1-12)
      const tradeYear = tradeDate.getFullYear();
    
      // Log para debuggear
      console.log('Filtrando', { tradeMonth, tradeYear, selectedMonth: selectedFilters.months, selectedYear: selectedFilters.years });
    
      return (
        (selectedFilters.signals.length === 0 || selectedFilters.signals.includes(trade.Signal)) &&
        (selectedFilters.types.length === 0 || selectedFilters.types.includes(trade.Type)) &&
        (selectedFilters.months.length === 0 || selectedFilters.months.map(Number).includes(tradeMonth)) && // Asegúrate de que los meses en el filtro sean números y compáralos
        (selectedFilters.years.length === 0 || selectedFilters.years.map(Number).includes(tradeYear))
      );
    });
    

  const chartData = {
    labels: filteredTrades.map(trade => trade.Datetime_Cierre),
    datasets: [
      {
        label: 'Profit',
        data: filteredTrades.map(trade => trade.Profit),
        borderColor: 'rgba(75,192,192,1)',
        backgroundColor: 'rgba(75,192,192,0.2)',
      },
    ],
  };

  const getChartOptions = (isMobile) => {
    return {
      scales: {
        y: {
          beginAtZero: true,
        },
        x: {
          ticks: {
            autoSkip: true,
            maxTicksLimit: isMobile ? 5 : 20 // Reduce el número de ticks en móviles
          }
        }
      },
      plugins: {
          datalabels: {
    display: false // ← Esta línea es la clave
  },
        legend: {
          display: !isMobile, // Oculta la leyenda en móviles para ahorrar espacio
        },
        title: {
          display: true,
          text: 'Profit vs Distribución Normal',
          font: {
            size: isMobile ? 14 : 20 // Ajusta el tamaño del texto del título
          }
        }
      },
      maintainAspectRatio: false // Importante para asegurar que el gráfico se ajuste al contenedor
    };
  };

  
  // Calcular la media de Profit
  const sumProfit = filteredTrades.reduce((acc, trade) => acc + parseFloat(trade.Profit), 0);
 
  const meanProfit = sumProfit / filteredTrades.length;

  // Calcular la desviación estándar de Profit
  const sumSquaredDiff = filteredTrades.reduce((acc, trade) => acc + Math.pow(parseFloat(trade.Profit) - meanProfit, 2), 0);
  const stdDeviationProfit = Math.sqrt(sumSquaredDiff / filteredTrades.length);
  
  const scatterChartData1 = {
    datasets: [
      {
        label: 'Profit vs. Normal_Dist_1',
        data: filteredTrades.map(trade => ({
          x: parseFloat(trade.Profit),
          y: parseFloat(trade.Normal_Dist_1),
        })),
        backgroundColor: 'rgba(255, 135, 0, 1)',
        order:2
      },
      // Línea para la
      {
        type: 'line',
        label: 'Media',
        borderColor: '#48FD90',
        borderWidth: 2,
        fill: false,
        data: [
          { x: meanProfit, y: Math.min(...filteredTrades.map(trade => parseFloat(trade.Normal_Dist_1))) },
          { x: meanProfit, y: Math.max(...filteredTrades.map(trade => parseFloat(trade.Normal_Dist_1))) },
        ],
        borderDash: [5, 5],
        order:1
      },
      // Media + 1 Std
      {
        type: 'line',
        label: 'Media + 1 Std',
        borderColor: 'rgb(0, 251, 255)',
        borderWidth: 2,
        fill: false,
        data: [
          { x: meanProfit + stdDeviationProfit, y: Math.min(...filteredTrades.map(trade => parseFloat(trade.Normal_Dist_1))) },
          { x: meanProfit + stdDeviationProfit, y: Math.max(...filteredTrades.map(trade => parseFloat(trade.Normal_Dist_1))) },
        ],
        borderDash: [5, 5],
        order:1
      },
      // Media - 1 Std
      {
        type: 'line',
        label: 'Media - 1 Std',
        borderColor: 'rgb(0, 251, 255)',
        borderWidth: 2,
        fill: false,
        data: [
          { x: meanProfit - stdDeviationProfit, y: Math.min(...filteredTrades.map(trade => parseFloat(trade.Normal_Dist_1))) },
          { x: meanProfit - stdDeviationProfit, y: Math.max(...filteredTrades.map(trade => parseFloat(trade.Normal_Dist_1))) },
        ],
        borderDash: [5, 5],
        order:1
      },
      // Media + 2 Std
      {
        type: 'line',
        label: 'Media + 2 Std',
        borderColor: '#FD48DC',
        borderWidth: 2,
        fill: false,
        data: [
          { x: meanProfit + 2 * stdDeviationProfit, y: Math.min(...filteredTrades.map(trade => parseFloat(trade.Normal_Dist_1))) },
          { x: meanProfit + 2 * stdDeviationProfit, y: Math.max(...filteredTrades.map(trade => parseFloat(trade.Normal_Dist_1))) },
        ],
        borderDash: [5, 5],
        order:1
      },
      // Media - 2 Std
      {
        type: 'line',
        label: 'Media - 2 Std',
        borderColor: '#FD48DC',
        borderWidth: 2,
        fill: false,
        data: [
          { x: meanProfit - 2 * stdDeviationProfit, y: Math.min(...filteredTrades.map(trade => parseFloat(trade.Normal_Dist_1))) },
          { x: meanProfit - 2 * stdDeviationProfit, y: Math.max(...filteredTrades.map(trade => parseFloat(trade.Normal_Dist_1))) },
        ],
        borderDash: [5, 5],
        order:1
      },
    ],
  };
  
  
  const scatterChartOptions1 = {
    plugins: {
      title: {
        display: true,
        text: 'Profit vs Distribución Normal',
        color: 'white', // Título del gráfico en blanco
      },
      legend: {
        labels: {
          color: 'white' // Color del texto de la leyenda
        }
      },
      datalabels: {
        display: false // Desactiva las etiquetas de datos
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Profit',
          color: 'white', // Nombre del eje X en blanco
        },
        ticks: {
          color: 'white', // Ticks del eje X en blanco
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.1)', // Color de la cuadrícula del eje X, más sutil
        }
      },
      y: {
        title: {
          display: true,
          text: 'Normal Distribution',
          color: 'white', // Nombre del eje Y en blanco
        },
        ticks: {
          color: 'white', // Ticks del eje Y en blanco
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.1)', // Color de la cuadrícula del eje Y, más sutil
        }
      }
    }
  };
  

  
  const scatterChartData2 = {
    datasets: [
      {
        label: 'ID vs. Profit',
        data: filteredTrades.map(trade => ({
          x: trade.ID,
          y: parseFloat(trade.Profit),
        })),
        backgroundColor: 'rgba(255, 135, 0, 1)',
        order:2
      },
      // Línea para la Media de Profit
      {
        type: 'line',
        label: 'Media',
        borderColor: '#48FD90',
        borderWidth: 2,
        fill: false,
        data: [
          { x: Math.min(...filteredTrades.map(trade => trade.ID)), y: meanProfit },
          { x: Math.max(...filteredTrades.map(trade => trade.ID)), y: meanProfit },
        ],
        borderDash: [5, 5],
        order:1
      },
      // Media + 1 Std
      {
        type: 'line',
        label: 'Media + 1 Std',
        borderColor: 'rgb(0, 251, 255)',
        borderWidth: 2,
        fill: false,
        data: [
          { x: Math.min(...filteredTrades.map(trade => trade.ID)), y: meanProfit + stdDeviationProfit },
          { x: Math.max(...filteredTrades.map(trade => trade.ID)), y: meanProfit + stdDeviationProfit },
        ],
        borderDash: [5, 5],
        order:1
      },
      // Media - 1 Std
      {
        type: 'line',
        label: 'Media - 1 Std',
        borderColor: 'rgb(0, 251, 255)',
        borderWidth: 2,
        fill: false,
        data: [
          { x: Math.min(...filteredTrades.map(trade => trade.ID)), y: meanProfit - stdDeviationProfit },
          { x: Math.max(...filteredTrades.map(trade => trade.ID)), y: meanProfit - stdDeviationProfit },
        ],
        borderDash: [5, 5],
        order:1
      },
      // Media + 2 Std
      {
        type: 'line',
        label: 'Media + 2 Std',
        borderColor: '#FD48DC',
        borderWidth: 2,
        fill: false,
        data: [
          { x: Math.min(...filteredTrades.map(trade => trade.ID)), y: meanProfit + 2 * stdDeviationProfit },
          { x: Math.max(...filteredTrades.map(trade => trade.ID)), y: meanProfit + 2 * stdDeviationProfit },
        ],
        borderDash: [5, 5],
        order:1
      },
      // Media - 2 Std
      {
        type: 'line',
        label: 'Media - 2 Std',
        borderColor: '#FD48DC',
        borderWidth: 2,
        fill: false,
        data: [
          { x: Math.min(...filteredTrades.map(trade => trade.ID)), y: meanProfit - 2 * stdDeviationProfit },
          { x: Math.max(...filteredTrades.map(trade => trade.ID)), y: meanProfit - 2 * stdDeviationProfit },
        ],
        borderDash: [5, 5],
        order:1
      },
    ],
  };
  
  // Calcular métricas
const totalTrades = filteredTrades.length;
const tradesPositivos = filteredTrades.filter(trade => trade.Profit > 0).length;
const tradesNegativos = filteredTrades.filter(trade => trade.Profit < 0).length;
const media = totalTrades > 0 ? filteredTrades.reduce((acc, trade) => acc + trade.Profit, 0) / totalTrades : 0;
const desviacionEstandar = Math.sqrt(filteredTrades.reduce((acc, trade) => acc + Math.pow(trade.Profit - media, 2), 0) / totalTrades);

// Calcular el porcentaje de trades ganadores
const porcentajeGanadores = totalTrades > 0 ? (tradesPositivos / totalTrades) * 100 : 0;
const porcentajeGanadores2 = totalTrades > 0 ? (tradesPositivos / totalTrades) : 0;
  
const FilterDropdown = ({ label, options, selected, onChange }) => (
  <FormControl fullWidth>
    <InputLabel>{label}</InputLabel>
    <Select
      value={selected}
      label={label}
      onChange={(event) => onChange(event.target.value)}
    >
      {options.map((option, index) => (
        <MenuItem key={index} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);


return (
  <Box sx={{ p: 3, backgroundColor: '#121212', color: '#FFF' }}>
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-around', flexWrap: 'wrap', mt: 4 }}>
          <Box sx={{ width: { xs: '100%', sm: '50%' }, height: chartHeight, mb: isMobile ? 2 : 0  }}>
              <Scatter data={scatterChartData1} options={getChartOptions(isMobile)} />
          </Box>
          <Box sx={{ width: { xs: '100%', sm: '50%' }, height: chartHeight, mb: isMobile ? 2 : 0  }}>
              <Scatter data={scatterChartData2} options={getChartOptions(isMobile)} />
          </Box>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(5, 1fr)' }, gap: 2, mt: 2 }}>
          <Box>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>Signals</Typography>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(3, 1fr)' }, gap: 1 }}>
                  {uniqueSignals.map(signal => (
                      <Button
                          key={signal}
                          variant={selectedFilters.signals.includes(signal) ? "contained" : "outlined"}
                          onClick={() => handleFilterClick('signals', signal)}
                          sx={{
                              backgroundColor: selectedFilters.signals.includes(signal) ? '#FF8700' : '#FFFFFF',
                              color: selectedFilters.signals.includes(signal) ? '#FFFFFF' : '#000000',
                              '&:hover': {
                                  backgroundColor: selectedFilters.signals.includes(signal) ? '#E65A00' : '#F5F5F5',
                              },
                              border: '1px solid #FF8700',
                              boxShadow: 'none',
                              '&:active': {
                                  boxShadow: 'none',
                              },
                          }}
                      >
                          {signal}
                      </Button>
                  ))}
              </Box>
          </Box>
          <Box>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>Type</Typography>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(3, 1fr)' }, gap: 1 }}>
                  {uniqueTypes.map(type => (
                      <Button
                          key={type}
                          variant="contained"
                          onClick={() => handleFilterClick('types', type)}
                          sx={{
                              backgroundColor: selectedFilters.types.includes(type) ? '#FF8700' : '#FFFFFF',
                              color: selectedFilters.types.includes(type) ? '#FFFFFF' : '#000000',
                              '&:hover': {
                                  backgroundColor: selectedFilters.types.includes(type) ? '#E65A00' : '#F5F5F5',
                              },
                              border: '1px solid #FF8700',
                              boxShadow: 'none',
                              '&:active': {
                                  boxShadow: 'none',
                              },
                          }}
                      >
                          {type}
                      </Button>
                  ))}
              </Box>
          </Box>
          <Box>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>Mes</Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {monthOptions.map((month, index) => (
                      <Button
                          key={month}
                          variant={selectedFilters.months.includes(index.toString()) ? "contained" : "outlined"}
                          onClick={() => handleFilterClick('months', index.toString())}
                          sx={{
                              backgroundColor: selectedFilters.months.includes(index.toString()) ? '#FF8700' : '#FFFFFF',
                              color: selectedFilters.months.includes(index.toString()) ? '#FFFFFF' : '#000000',
                              '&:hover': {
                                  backgroundColor: selectedFilters.months.includes(index.toString()) ? '#E65A00' : '#F5F5F5',
                              },
                              border: '1px solid #FF8700',
                              boxShadow: 'none',
                              '&:active': {
                                  boxShadow: 'none',
                              },
                          }}
                      >
                          {month}
                      </Button>
                  ))}
              </Box>
          </Box>
          <Box>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>Año </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {uniqueYears.map(year => (
                      <Button
                          key={year}
                          variant={selectedFilters.years.includes(year.toString()) ? "contained" : "outlined"}
                          onClick={() => handleFilterClick('years', year.toString())}
                          sx={{
                              backgroundColor: selectedFilters.years.includes(year.toString()) ? '#FF8700' : '#FFFFFF',
                              color: selectedFilters.years.includes(year.toString()) ? '#FFFFFF' : '#000000',
                              '&:hover': {
                                  backgroundColor: selectedFilters.years.includes(year.toString()) ? '#E65A00' : '#F5F5F5',
                              },
                              border: '1px solid #FF8700',
                              boxShadow: 'none',
                              '&:active': {
                                  boxShadow: 'none',
                              },
                          }}
                      >
                          {year}
                      </Button>
                  ))}
              </Box>
          </Box>
          <Box sx={{
    display: 'flex',
    flexWrap: 'wrap',  // Permite que los elementos se envuelvan en la vista móvil
    gap: 1,
}}>
    {[
        `Media: ${meanProfit.toFixed(2)}`,
        `Desviación Estándar: ${stdDeviationProfit.toFixed(2)}`,
        `Total Trades: ${totalTrades}`,
        `Trades Positivos: ${tradesPositivos}`,
        `Trades Negativos: ${tradesNegativos}`,
        `Porcentaje Ganadores: ${porcentajeGanadores.toFixed(2)}%`,
    ].map(metric => (
        <Box key={metric} sx={{
            flex: 1,  // Cada caja tomará un espacio igual en la fila
            minHeight: '80px', // Asegura una altura mínima
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center', // Centra el contenido verticalmente
            alignItems: 'center', // Centra el contenido horizontalmente
            borderRadius: '4px',
            border: '1px solid #FFA500',
            backgroundColor: '#424242',
            color: '#FFF',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            fontSize: '0.875rem' // Tamaño de fuente uniforme
        }}>
            <Typography variant="h6" component="div" sx={{ textAlign: 'center' }}>{metric}</Typography>
        </Box>
    ))}
    <Box sx={{ flexBasis: '100%' }}> {/* Esto hace que el GaugeChart ocupe toda la anchura disponible en la siguiente fila */}
        <GaugeChart id="gauge-chart1"
            nrOfLevels={20}
            percent={porcentajeGanadores2.toFixed(2)}
            colors={["#F30D09", "#F39009", "#EFF309", "#93F309", "#09F35E"]}
            style={{ width: '100%' }} // Asegura que el GaugeChart use todo el ancho disponible
        />
    </Box>
</Box>
    </Box>
  </Box>
);
}


export default SystemTrades;
